import { render, staticRenderFns } from "./PersonnelAuthority.vue?vue&type=template&id=e0d51c40&scoped=true&"
import script from "./PersonnelAuthority.vue?vue&type=script&lang=js&"
export * from "./PersonnelAuthority.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelAuthority.vue?vue&type=style&index=0&id=e0d51c40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d51c40",
  null
  
)

export default component.exports